import { useMemo } from 'react';
import { useMapValidator } from './useMapValidator.ts';
import { usePlayerValidators } from './usePlayerValidators.ts';
import { useGameStore } from '../GameStoreContext.ts';
import { MechanicValidatorShip } from '@colonist/game-mechanic-validators';
export const useMechanicValidatorShip = ()=>{
    const { playerValidators } = usePlayerValidators();
    const mapValidator = useMapValidator();
    const mechanicShipState = useGameStore((state)=>state.gameState.mechanicShipState);
    const mechanicPirateState = useGameStore((state)=>state.gameState.mechanicPirateState);
    return useMemo(()=>{
        if (!mechanicShipState) return undefined;
        return new MechanicValidatorShip(playerValidators, mapValidator, mechanicShipState, mechanicPirateState);
    }, [
        playerValidators,
        mapValidator,
        mechanicShipState,
        mechanicPirateState
    ]);
};
